import React, { useEffect, useRef, useState } from 'react';
import styles from './header.module.scss';
import { DownOutlined, PoweroffOutlined } from '@ant-design/icons';
import { Button, Menu, Dropdown, Space, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { loginActionTypes, unsavedFormChangesActionTypes } from '../../redux/actionTypes';
import { useHistory } from 'react-router-dom';
import { Emitter } from '../../utils/service';
import SOCKET_CONSTANTS from '../../constants/event.constant';
import {
  getUserEmail,
  openNotification,
  pushToLink,
  getFullName,
  isAdmin,
  getCompanyName,
  isCustomerAdmin,
} from '../../utils/helpers/global';
import headerLogo from '../../assets/HomePage/headerLogo.svg';
import {
  eventOperation,
  eventType,
  processesStatuses,
  routeConstant,
  SEED_ADMIN_EMAIL,
  stringConstant,
  themeColor,
  controlRoomVersion,
} from '../../constants/app.constants';
import logotft from '../../assets/HomePage/tftlinkIcon.svg';
import { showAlert } from '../../utils/helpers/toastify';

const AppHeader = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  let userDetails = localStorage.getItem('user');
  const loginState = useSelector((state) => state.login);
  if (userDetails) userDetails = JSON.parse(userDetails);
  const profileIconName = getFullName();
  const profileIconEmailName = getUserEmail();
  const initials = profileIconName
    ?.split(' ')
    .map((name) => name[0])
    .join('')
    .toUpperCase();
  const [alertMessage, setAlertMessage] = useState();

  const title = () => {
    return (
      <div className={styles.profileIconTooltip}>
        <p>{profileIconName}</p>
        <p>{profileIconEmailName}</p>
        {!isAdmin() && <p>{getCompanyName()}</p>}
      </div>
    );
  };
  const notificationHandler = (data) => {
    let message = '';
    let status = data?.content?.data?.status;
    if (data && data.content && data.content.type && data.content.operation) {
      let type = data.content.type;
      let operation = data.content.operation;
      switch (type) {
        case eventType.agent:
          switch (operation) {
            case eventOperation.insert:
              message = `Agent ${data.content?.data?.deviceId} Added successfully`;
              break;
            case eventOperation.update:
              message = `Agent ${data.content?.data?.deviceId} ${status == 0 ? 'Disconnected' : 'Connected'} successfully`;
              break;
          }
          break;
        case eventType.process:
          switch (operation) {
            case eventOperation.insert:
              message = `Process with Id : ${data.content?.data?.id?.slice(0, 8)}... Added successfully`;
              break;
            case eventOperation.update:
              if (data.content?.data?.status === processesStatuses.running) {
                message = `Process with Id : ${data.content?.data?.id?.slice(0, 8)}... Started Running`;
              } else if (data.content?.data?.status === processesStatuses.executed) {
                message = `Process with Id : ${data.content?.data?.id?.slice(0, 8)}... Completed Successfully`;
              } else if (data.content?.data?.status === processesStatuses.failed) {
                message = `Process with Id : ${data.content?.data?.id?.slice(0, 8)}... Failed`;
              } else if (data.content?.data?.status === processesStatuses.canceled) {
                message = `Process with Id : ${data.content?.data?.id?.slice(0, 8)}... Canceled`;
              } else if (status === processesStatuses.agentDisconnected) {
                message = `Process with Id : ${data.content?.data?.id?.slice(0, 8)}... failed since agent is disconnected`;
              }
              break;
          }
          break;
        case eventType.processExecutionLog:
          switch (operation) {
            case eventOperation.insert:
              break;
            case eventOperation.update:
              break;
          }
          break;
      }
    }
    if (message) {
      openNotification(message);
      message = '';
    }
  };
  useEffect(() => {
    Emitter.off(SOCKET_CONSTANTS.INCOMING_NOTIFICATION_EVENT_NAME, notificationHandler);
    Emitter.on(SOCKET_CONSTANTS.INCOMING_NOTIFICATION_EVENT_NAME, notificationHandler);
    return () => {
      Emitter.off(SOCKET_CONSTANTS.INCOMING_NOTIFICATION_EVENT_NAME, notificationHandler);
    };
  }, []);

  const goToDashboard = () => {
    pushToLink(history, routeConstant.CONTROL_ROOM_BASE_PATH);
  };

  const menu = (
    <Menu>
      <Menu.Item
        disabled={getUserEmail() === SEED_ADMIN_EMAIL}
        onClick={() => {
          loginState.success
            ? history.push(routeConstant.LOGGEDIN_RESET_PASSWORD_PATH)
            : history.push(routeConstant.RESET_PASSWORD_PATH);
        }}
      >
        {stringConstant.ResetPasswordTitle}
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          dispatch({ type: loginActionTypes.LOGOUT });
          dispatch({ type: unsavedFormChangesActionTypes.RESET_FORM_CHANGES });
          history.push('/');
          localStorage.setItem('logout', Date.now().toString());
        }}
      >
        Logout
      </Menu.Item>
      <Menu.Item disabled style={{ cursor: 'default', color: themeColor.versionColor }}>
        v{controlRoomVersion.version}
      </Menu.Item>
    </Menu>
  );

  useEffect(() => {
    if (alertMessage && alertMessage.type) {
      showAlert({
        type: alertMessage.type,
        message: alertMessage.message,
      });
    }
    setAlertMessage('');
  }, [alertMessage]);

  return (
    <div className={`${styles.header} ${props.showShadow && styles.homePageHeader}`}>
      <img
        src={headerLogo}
        onClick={goToDashboard}
        alt="Header logo"
        className={styles.headerLogo}
      />
      {props.showDropdown && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            color: 'black',
            alignItems: 'center',
          }}
          className={styles.showDropdown}
        >
          <Tooltip
            placement="top"
            overlayInnerStyle={{
              background: themeColor.toolTipColor,
              fontSize: '11px',
              color: themeColor.toolTipTextColor,
              cursor: 'pointer',
              minWidth: '100px',
              textAlign: 'center',
              placement: 'bottom',
            }}
            getPopupContainer={(trigger) => trigger.parentElement}
            title={title}
          >
            <div className={styles.profileIcon}>{initials}</div>
          </Tooltip>
          <Space direction="vertical" wrap style={{ marginBottom: '0' }}>
            <Dropdown overlay={menu} placement="bottomCenter">
              <Button
                style={{
                  color: 'black',
                  fontSize: '20px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                icon={<DownOutlined />}
                type="link"
              />
            </Dropdown>
          </Space>
        </div>
      )}
      <div className={styles.rightContainer}>
        <a
          href="https://www.tftus.com/"
          target="_blank"
          rel="noreferrer"
          className={styles.tftLink}
        >
          <img src={logotft} className={styles.tftLinkImage} />
          <span className={styles.tftLinkText}>Think Future Technologies</span>
        </a>
        {loginState?.success && (
          <button onClick={goToDashboard} className={styles.dashboardButton}>
            Go To Dashboard
          </button>
        )}
        {!loginState?.success && (
          <button
            onClick={() => {
              history.push('/login');
            }}
            className={styles.loginButton}
          >
            Login
          </button>
        )}
      </div>
    </div>
  );
};

export default AppHeader;
